export default {
	"userOrganization": {
		"tipsUnbind": "ลบ",
		"allStatus": "สถานะทั้งหมด",
		"userName": "ชื่อ",
		"mobile": "โทรศัพท์มือถือ",
		"selectRole": "กรุณาเลือกบทบาทหน้าที่",
		"selectDepartment": "กรุณาเลือกแผนก",
		"selectBusinessUnit": "กรุณาเลือกแผนก/ฝ่าย",
		"selectAllBusinessUnit": "เลือกหน่วยงานทั้งหมด",
		"noSubordinate": "ไม่มีผู้อยู่ใต้บังคับบัญชา",
		"noMatchDepartment": "ไม่มีแผนกที่ตรงกัน",
		"isDisabled": "ปิดใช้งาน",
		"department": "แผนก",
		"onlyCurrentOrganization": "เห็นเฉพาะบุคลากรขององค์กรปัจจุบัน",
		"organization": "องค์กร",
		"organizationName": "ชื่อองค์กร",
		"role": "บทบาทหน้าที่",
		"roleName": "ชื่อบทบาทหน้าที่",
		"addNewRole": "เพิ่มบทบาทหน้าที่ใหม่",
		"addUser": "เพิ่มบุคคล",
		"employeeNumber": "รหัสเจ้าหน้าที่",
		"userGender": "เพศ",
		"userPosition": "ตำแหน่ง",
		"userEmail": "อีเมล",
		"telephone": "โทรศัพท์พื้นฐาน",
		"userWechat": "วีแชท",
		"userModify": "อัพเดทข้อมูลบุคลากร",
		"modifyAvatar": "แก้ไขอวาตาร์",
		"credentialNo": "เลขใบขับขี่",
		"addOrganization": "เพิ่มองค์กร",
		"confirmRemoveRole": "ท่านแน่ใจว่าจะลบบทบาทหน้าที่ของผู้ใช้ปัจจุบันหรือไม่?",
		"createUserSuccess": "เพิ่มข้อมูลบุคลากรเรียบร้อยแล้ว",
		"editUserSuccess": "อัพเดทข้อมูลบุคลากรเรียบร้อยแล้ว",
		"removeUserSuccess": "ลบข้อมูลบุคลากรเรียบร้อยแล้ว",
		"enableUserSuccess": "เปิดใช้งานบุคลากรเรียบร้อยแล้ว",
		"disableUserSuccess": "ปิดใช้งานบุคลากรเรียบร้อยแล้ว"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/userOrganization/userOrganization.js